import AbstractView from 'abstract';
import Vue from 'vue'
import store from 'definitions/store'

export class Main extends AbstractView {
  constructor(domElementId) {
    return super(domElementId);
  }

  init() {
    const Loader = () => import(/* webpackChunkName: "loader-plane" */ 'components/LoaderPlane')
    new Vue({
      el: "#" + this.elemId,
      store,
      render: h => h(Loader)
    })
  }
}
